/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Copy: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5 2C3.89543 2 3 2.89543 3 4V16C3 16.5523 3.44772 17 4 17C4.55229 17 5 16.5523 5 16L5 4L15 4C15.5523 4 16 3.55228 16 3C16 2.44772 15.5523 2 15 2H5ZM10 9.00002L19 9.00002V20H10V9.00002ZM19 7.00002L10 7.00002C8.89543 7.00002 8 7.89545 8 9.00002V20C8 21.1046 8.89543 22 10 22H19C20.1046 22 21 21.1046 21 20V9.00002C21 7.89544 20.1046 7.00002 19 7.00002Z'
      fill='currentColor'
    />
  </React.Fragment>
)
